var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"inlineFieldLabel"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.validation.$error)?_c('span',{staticClass:"error"},[_vm._v("Field is required")]):_vm._e()]),_c('md-field',[_c('md-input',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }